export default __webpack_public_path__ + "static/media/Nuestros_valores_1.d71bb5cc.png";